import Vue from 'vue'

import Ionic from '@ionic/vue';

Vue.use(Ionic);

import App from './App.vue'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
